module.exports = __webpack_public_path__ + "static/media/icon_comment-private-color.cd732344.svg";